import { render, staticRenderFns } from "./SectionSwitch.vue?vue&type=template&id=ae3e060c&"
import script from "./SectionSwitch.vue?vue&type=script&lang=ts&"
export * from "./SectionSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./SectionSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports